module.exports = __webpack_public_path__ + "static/media/event3.64ea7e1c.jpg";